export default "__VITE_ASSET__BjASh0qN__"